module.exports = __webpack_public_path__ + "img/img-intro2@2x.e12076d8.jpg";